


















import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import TimerDisplay from 'components/TimerDisplay.vue'

@Component({
  components: {
    TimerDisplay
  }
})
export default class Timer extends Vue {
  timeout = 0
  startTime: Date | string | number = new Date()
  milisecondsTotal = 0;
  miliseconds = 0
  seconds = 0
  minutes = 0
  hours = 0
  days = 0

  @Prop()
  readonly beginning!: Date | string | number | undefined

  @Prop()
  readonly deadline!: Date | string | number | undefined

  @Prop({ default: 333 })
  readonly step!: number

  @Prop({ default: () => { return () => new Date() } })
  readonly now!: () => Date

  get progress (): number {
    return this.milisecondsTotal ? this.miliseconds / this.milisecondsTotal : 0
  }

  @Watch('beginning', { immediate: true })
  beginingTick (beginning: Date | string | number | undefined) {
    this.startTime = beginning || this.now()
    if (this.deadline) {
      this.milisecondsTotal = Math.max(0, +(new Date(this.deadline)) - +(new Date(this.startTime)))
    } else {
      this.milisecondsTotal = 0
    }
    this.tick()
  }

  @Watch('deadline')
  deadlineTick (deadline: Date | string | number | undefined) {
    if (deadline) {
      this.milisecondsTotal = Math.max(0, +(new Date(deadline)) - +(new Date(this.startTime)))
    } else {
      this.milisecondsTotal = 0
    }
    this.tick()
  }

  tick () {
    const miliseconds = Math.max(0,  +(this.now()) - +(new Date(this.startTime)))
    this.setTime(miliseconds)
    if (this.milisecondsTotal && this.milisecondsTotal <= miliseconds) {
      this.timeout && window.clearTimeout(this.timeout)
      this.$emit('end')
    } else {
      this.timeout = window.setTimeout(() => {
        this.tick()
      }, Math.min(this.step, this.milisecondsTotal - miliseconds))
    }
  }

  setTime (miliseconds: number) {
    this.miliseconds = miliseconds
    this.seconds = Math.floor(this.miliseconds / 1000)
    this.minutes = Math.floor(this.seconds / 60)
    this.hours = Math.floor(this.minutes / 60)
    this.days = Math.floor(this.hours / 24)
    this.$emit('tick', {
      progress: this.progress,
      miliseconds: this.miliseconds,
      seconds: this.seconds,
      minutes: this.minutes,
      hours: this.hours,
      days: this.days
    })
  }

  destroyed () {
    this.timeout && window.clearTimeout(this.timeout)
  }
}
